import axios from 'axios';
import dayjs from 'dayjs';

const API_BASE_URL = 'https://plansync-backend-234288438538.us-central1.run.app/api';

const userid = localStorage.getItem('userid');

export const fetchParticipantCensus = async () => {
    const response = await axios.get(`${API_BASE_URL}/participant_census/${userid}/${dayjs().year()}`);
    return response.data;
};

export const fetchClientNames = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/clients/${userid}/${dayjs().year()}`);
        // console.log('Response from client names API:', response.data);
        return response.data.clients || [];
    } catch (error) {
        // console.error('Error fetching client names:', error);
        return [];
    }
};

export const sendSurveyInvitations = async (participants, companyName, advisorName) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/send-participant-surveys`, {
            advisor_id: userid,
            year: dayjs().year(),
            company_name: companyName,
            advisor_name: advisorName,
            participants: participants.map(p => ({
                name: p.name,
                email: p.email
            }))
        });
        return response.data;
    } catch (error) {
        console.error('Error sending survey invitations:', error);
        if (error.response) {
            throw new Error(error.response.data.detail || 'Failed to send surveys');
        }
        throw new Error('Network error while sending surveys');
    }
};


export const fetchAdvisorNames = async () => {
    const response = await axios.get(`${API_BASE_URL}/advisor-names/${userid}`);
    // console.log('Response from advisor names API:', response.data);

    // Extract advisor names from the response

    return response.data;
};
